import URL_PATH from "../constants/routes";
import API_PATH from "../constants/apiPath";
import { API_ERROR_TYPE } from "../constants/errorType";
import { refreshAccessToken } from "./user";

// 동시에 여러 요청이 401을 받아도 재발급은 한 번만 수행하고 나머지는 결과를 기다린다
let refreshPromise = null;

const refreshAccessTokenOnce = () => {
  if (!refreshPromise) {
    refreshPromise = refreshAccessToken().finally(() => {
      refreshPromise = null;
    });
  }
  return refreshPromise;
};

const redirectToLogin = () => {
  // 현재 페이지가 홈화면(로그인)인 경우 이동하지 않음
  if (window.location.pathname === URL_PATH.home) {
    return;
  }
  window.location.replace(URL_PATH.home);
};

/**
 * refreshToken 만료된 경우 -
 * 인증번호 잘못된 경우 -
 * accessToken 만료된 경우 -
 * refreshToken 재발급 받아야 하는 경우 홈화면(로그인 유도)으로 이동
 * @param {*} error
 * @param {*} axiosInstance
 * @returns
 */

export const handle401Error = async (error, axiosInstance) => {
  const errorType = error.response.data?.type; // 중복 제거를 위한 변수 선언
  const originalRequest = error.config;

  // 재발급 요청 자체가 401이면 refreshToken이 유효하지 않으므로 로그인 유도
  // (백엔드는 refreshToken 검증 실패도 accessToken 실패와 같은 type으로 응답한다)
  if (originalRequest?.url === API_PATH.refreshAccessToken) {
    redirectToLogin();
    return;
  }

  if (
    API_ERROR_TYPE.REFRESH_TOKEN_INVALID === errorType ||
    API_ERROR_TYPE.REFRESH_TOKEN_EXPIRED === errorType ||
    API_ERROR_TYPE.REFRESH_TOKEN_FAILED === errorType ||
    API_ERROR_TYPE.REFRESH_TOKEN_HEADER_MISSING === errorType
  ) {
    redirectToLogin();
  } else if (
    API_ERROR_TYPE.ACCESS_TOKEN_INVALID === errorType ||
    API_ERROR_TYPE.ACCESS_TOKEN_EXPIRED === errorType ||
    API_ERROR_TYPE.ACCESS_TOKEN_FAILED === errorType ||
    API_ERROR_TYPE.ACCESS_TOKEN_HEADER_MISSING === errorType
  ) {
    // accessToken 재발급 받아야 하는 경우
    if (!originalRequest._retry) {
      originalRequest._retry = true;

      try {
        await refreshAccessTokenOnce(); // accessToken 재발급
        return axiosInstance(originalRequest); // 원래 요청 재시도
      } catch (refreshError) {
        console.error("🚀 ~ refreshAccessToken 발급 에러:", refreshError);
        return Promise.reject(refreshError);
      }
    }
  }
};
